import React from "react"
import { Dropdown, DropdownButton } from "react-bootstrap"
import { injectIntl } from "react-intl"

import { withSampleConfig } from "../../../config/SampleConfigProvider"
import SampleStatus from "./SampleStatus"

function ToggleMethodStatus({
  methodInfo,
  name,
  smpID,
  isLoading = false,
  onSuccess,
  onError,
  extraStyle = {},
  reloadSampleRoundsTable, // From SampleConfigProvider
  reloadSampleTable, // From SampleConfigProvider
  updateSampleMethod, // From SampleConfigProvider
  user_permissions = [], // From SampleConfigProvider
  intl, // From injectIntl
}) {
  const completeSampleMethod = (method, status) => {
    if (status === "analyzed") {
      if (
        !confirm(
          `${intl.formatMessage({
            id: "samplemanagement.confirm.method.completion",
          })}: ${method}`,
        )
      ) {
        return false
      }
    }

    updateSampleMethod(
      smpID,
      method,
      status,
      () => {
        if (onSuccess) {
          onSuccess()
        } else {
          reloadSampleRoundsTable()
          reloadSampleTable()
        }
      },
      () => {
        alert(
          intl.formatMessage({
            id: "samplemanagement.error.unable.to.update.method",
          }),
        )
        onError && onError()
      },
    )
  }

  const editableStatuses = ["pending_analysis", "in_progress", "analyzed"]
  if (!editableStatuses.includes(methodInfo?.status) || !methodInfo?.non_numerical_method)
    return (
      <div>
        <SampleStatus status={methodInfo?.status} extraStyle={extraStyle} />
      </div>
    )

  return (
    <DropdownButton
      id={"status-toggle"}
      variant={"outline-primary"}
      title={<SampleStatus status={methodInfo?.status} />}
      disabled={isLoading || !user_permissions.includes("change_sampleround")}
    >
      {editableStatuses.map((status, i) => (
        <Dropdown.Item key={`Item${i}`} onClick={() => completeSampleMethod(name, status)}>
          <SampleStatus status={status} />
        </Dropdown.Item>
      ))}
    </DropdownButton>
  )
}

export default injectIntl(withSampleConfig(ToggleMethodStatus))
